import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { PHBHPFeaturePackageConfigurationService } from "../ph-bhp-feature-package-configuration.service";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { PHBHPLayoutPackageService } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AppConfig } from "src/app/app.config";
import { TranslationKeys } from "ph-bhp-localization";
import { CatalogMasterService } from "../../services/catalog-master.service";
import { ProfessionalCategory } from "src/app/models/professional-category";

@Component({
  selector: "app-ph-bhp-configure-professional-category",
  templateUrl: "./ph-bhp-configure-professional-category.component.html",
  styleUrls: ["./ph-bhp-configure-professional-category.component.css"],
})
export class PhBhpConfigureProfessionalCategoryComponent
  implements OnInit, OnDestroy
{
  subscription: Subscription;
  gridData: ProfessionalCategory[];
  userData;
  modalRef: BsModalRef;
  searchText;
  @ViewChild("delmodal") delmodal: TemplateRef<any>;
  @ViewChild('grid') grid: any;
  deleteDataItem;
  deleterowIndex;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private service: PHBHPFeaturePackageConfigurationService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public appConfig: AppConfig,
    private catalogMasterService: CatalogMasterService
  ) {}

  ngOnInit() {
    this.getProfessionalCategoryList();
    this.subscription = this.layoutService.lang
      .asObservable()
      .subscribe((selectedLang) => {
        this.getProfessionalCategoryList();
      });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  // tslint:disable-next-line:member-ordering
  professionalCategoryModelGridEdit: any = new UntypedFormGroup({
    categoryName: new UntypedFormControl(
      "",
      Validators.compose([Validators.required, Validators.maxLength(60)])
    ),
  });
  fields: any[] = [
    {
      field: "categoryName",
      title: "CONFIGURE.PROFESSIONAL_CATEGORY",
      ngTextEditTemplate: {
        type: "text",
        maxLength: 60,
      },
    },
  ];
  pageInfo = {
    items: "CONFIGURE.PROFESSIONAL_CATEGORIES",
    itemsPerPageLabel: "CONFIGURE.PER_PAGE.PROFESSIONAL_CATEGORIES",
  };

  getProfessionalCategoryList() {
    this.layoutService.showLoader = true;
    this.catalogMasterService
      .getProfessionalCategories()
      .subscribe((res: ProfessionalCategory[]) => {
        this.layoutService.showLoader = false;
        this.gridData = res;
        this.changeLangForGridData();
      });
  }

  changeLangForGridData() {
    this.gridData.forEach((value, index) => {
      this.gridData[index].categoryName = this.layoutService.translateText(
        value.categoryName
      );
    });
  }

  handlerData({ handler, formGroup, isNew, dataItem, rowIndex }): void {
    this.userData = this.appConfig.userData;
    switch (handler) {
      case "saveHandler":
        var userId = this.userData.userId;
        var professionalCategoryData: ProfessionalCategory = formGroup.value;
        if (isNew) {
          professionalCategoryData.createdBy = userId;
          this.service
            .createProfessionalCategory(professionalCategoryData)
            .subscribe((res: ProfessionalCategory) => {
              this.layoutService.showSuccess(
                this.layoutService.translateText(
                  "CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.PROFESSIONAL_CATEGORY"
                )
              );
              this.getProfessionalCategoryList();
            });
        } else {
          var data = {
            categoryID: dataItem.categoryID,
            categoryName: professionalCategoryData.categoryName,
          };
          this.service
            .updateProfessionalCategory(dataItem.categoryID, data)
            .subscribe((res: ProfessionalCategory) => {
              this.gridData[rowIndex].categoryName =
                professionalCategoryData.categoryName;
              this.layoutService.showSuccess(
                this.layoutService.translateText(
                  "CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.PROFESSIONAL_CATEGORY"
                )
              );
            });
          this.getProfessionalCategoryList(); // to trigger the language change for the kendo grid when edit happens
        }
        break;
      case "removeHandler":
        this.openDeleteModal(this.delmodal, dataItem, rowIndex);
        break;
    }
  }
  openDeleteModal(deletemodal: TemplateRef<any>, dataItem, rowIndex) {
    this.deleteDataItem = dataItem;
    this.deleterowIndex = rowIndex;
    this.modalRef = this.modalService.show(
      deletemodal,
      Object.assign({}, { class: "w-420" })
    );
  }
  delete() {
    this.service
      .deleteProfessionalCategory(this.deleteDataItem.categoryID)
      .subscribe((res: ProfessionalCategory) => {
        // var data: ProfessionalCategory[] = JSON.parse(JSON.stringify(this.gridData));
        // data.splice(this.deleterowIndex, 1);
        // this.gridData = data;
        this.getProfessionalCategoryList();
      });
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  addRow() {
    this.grid.addRow();
  }

}
